import { Dispatch } from 'react';
import { InsuranceJourneyCoverDetailsType } from '../../../components/common/CommonTypes';
import ActionTypes from '../ActionTypes';

export const CoverDetailsPageEventHandlers = (
  coverDetails: InsuranceJourneyCoverDetailsType,
  dispatch: Dispatch<ActionTypes>
) => {
  return {
    onChangeEstimatedMileage: (value: string) => {
      dispatch({
        type: 'set-cover-details',
        coverDetails: { ...coverDetails, estimatedMileage: value }
      });
    },

    onChangeCarUse: (value: string) => {
      dispatch({
        type: 'set-cover-details',
        coverDetails: { ...coverDetails, carUses: value }
      });
    },

    onChangeEstimatedBusinessMileage: (value: string) => {
      dispatch({
        type: 'set-cover-details',
        coverDetails: { ...coverDetails, estimatedBusinessMileage: value }
      });
    },

    onChangeCoverStartDate: (value: Date | undefined) => {
      dispatch({
        type: 'set-cover-details',
        coverDetails: { ...coverDetails, coverStartDate: value }
      });
    },

    onChangeCoverStartTime: (value: string) => {
      dispatch({
        type: 'set-cover-details',
        coverDetails: { ...coverDetails, coverStartTime: value }
      });
    },

    onChangeRegisteredVehicleKeeper: (value: string) => {
      dispatch({
        type: 'set-cover-details',
        coverDetails: { ...coverDetails, registeredVehicleKeeper: value }
      });
    },

    onChangeRegisteredVehicleOwner: (value: string) => {
      dispatch({
        type: 'set-cover-details',
        coverDetails: { ...coverDetails, registeredVehicleOwner: value }
      });
    },

    onChangePaymentMode: (value: string) => {
      dispatch({
        type: 'set-cover-details',
        coverDetails: { ...coverDetails, paymentMode: value }
      });
    }
  };
};
